<template>
    <div class="form" >
        <ValidationObserver ref="form">
            <span class="login__sub-title text-left mb-2">change email</span>
            <div class="row mb-3">
                <ValidationProvider
                    class="col-sm-4"
                    name="Old Email"
                    rules="email"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">Old Email</span>
                        <input
                            type="email"
                            class="form-control"
                            v-model="user.email"
                        >
                        <FormError :error="errors[0]" name="Old Email"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-4"
                    name="New Email"
                    rules="email"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">New Email</span>
                        <input
                            type="email"
                            class="form-control"
                            v-model="form.new_email"
                        >
                        <FormError :error="errors[0]" name="New Email"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-4"
                    name="Confirm Email"
                    rules="confirmed:New Email"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">Confirm Email</span>
                        <input
                            type="email"
                            class="form-control"
                            v-model="form.confirm_email"
                            data-vv-as="New Email"
                        >
                        <FormError :error="errors[0]" name="Confirm Email"></FormError>
                    </label>
                </ValidationProvider>
            </div>

            <span class="login__sub-title text-left mb-2">change password</span>
            <div class="row">
                <ValidationProvider
                    class="col-sm-4"
                    name="Old Password"
                    rules="min:8|max:20|password_strength|required"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">Old Password</span>
                        <input
                            :type="showOldPassword ? 'text' : 'password'"
                            class="form-control password"
                            v-model="form.old_password"
                        >
                        <button
                            type="button"
                            class="view-pass" aria-label="View password"
                            @click="togglePasswordVisibility('showOldPassword')"
                        >
                            <svg width="16" height="16" aria-hidden="true">
                                <use href="/img/svg/symbol-defs.svg#icon-view"></use>
                            </svg>
                        </button>
                    </label>
                    <FormError :error="errors[0]" style="color: red; font-size: 10px" name="Old Password"/>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-4"
                    name="New Password"
                    rules="min:8|max:20|password_strength|required"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">New Password*</span>
                        <input
                            :type="showNewPassword ? 'text' : 'password'"
                            class="form-control password"
                            v-model="form.new_password"
                        >
                        <button
                            type="button"
                            class="view-pass"
                            @click="togglePasswordVisibility('showNewPassword')"
                        >
                            <svg width="16" height="16" aria-hidden="true">
                                <use href="/img/svg/symbol-defs.svg#icon-view"></use>
                            </svg>
                        </button>
                    </label>
                    <FormError :error="errors[0]" style="color: red; font-size: 10px" name="New Password"></FormError>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-4"
                    name="Confirm Password"
                    rules="confirmed:New Password"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">Confirm Password*</span>
                        <input
                            :type="showConfirmPassword ? 'text' : 'password'"
                            class="form-control password"
                            v-model="form.new_password_confirmation"
                            data-vv-as="New Password"
                        >
                        <FormError :error="errors[0]" name="Confirm Password"></FormError>
                        <button
                            type="button"
                            class="view-pass"
                            @click="togglePasswordVisibility('showConfirmPassword')"
                        >
                            <svg width="16" height="16" aria-hidden="true">
                                <use href="/img/svg/symbol-defs.svg#icon-view"></use>
                            </svg>
                        </button>
                    </label>
                </ValidationProvider>
            </div>

            <div class="row" style="margin-top: 20px;">
                <div class="col-sm-6">
                    <div class="form-group text-center text-sm-left">
                        <button
                            type="reset"
                            class="btn btn_primary-outline pl-5 pr-5"
                            @click="reloadPage"
                        >
                            <span>Cancel</span>
                        </button>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group text-center text-sm-right">
                        <button
                            type="submit"
                            class="btn btn_golden"
                            @click="validate"
                        >
                            <span class="pl-5 pr-5">Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>

</template>

<script>
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import FormError from "./FormError.vue";
import CommonServices from "../../services/CommonServices";
import ModalHandler from "../../mixins/ModalHandler";

export default {
    name: 'ProfileSettings',
    components: {FormError},
    mixins: [ModalHandler],
    data() {
        return {
            user: null,
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
            confirm_password: null,
            old_email: null,
            passwordError: null,
            form: {
                new_email: null,
                confirm_email: null,
                old_password: null,
                new_password: null,
                new_password_confirmation: null
            }
        }
    },
    mounted() {
        this.getUserInfo()
    },
    methods: {
        async getUserInfo() {
            try {
                const {data : response } = await CommonServices.getLoggedUser()
                this.user = response
            } catch {

            }
        },
        togglePasswordVisibility(input) {
            this[input] = !this[input];
        },
        async validate() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }

            if (
                (this.form.new_email && (!this.user.email || !this.form.confirm_email)) ||
                (this.form.new_password && (!this.form.old_password || !this.form.new_password_confirmation))
            ) {
                this.$showValidationErrorMessage('Enter your old email or old password to update your data!');
                return;
            }

            if (!this.form.new_email && !this.form.new_password) {
                this.$showValidationErrorMessage('Please enter new password or email');
                return
            }

            await this.updateProfileSettings()
        },
        async updateProfileSettings() {
            const data = {
                old_email: this.user.email,
                ...this.form
            }
            try {
                await CommonServices.updateAccountSettings(data);
                this.$showSuccessMessage('Profile was successfully updated')
            } catch (error) {
                console.log(error)
                this.$showErrorMessage('The profile has not been updated')
            }
        }
    },

}

</script>


<style scoped>

</style>
